<span class="btn-created" (click)="filterCreatedByTable(params?.data?.buyer)">
  {{ params.value }}
</span>
